<template>
  <basic-container>
    <div class="about-wrapper">
      <el-image src="img/bg/logo3.png"
                fit="contain"
                class="logo"></el-image>
      <div class="v-label">V1.0.6_Z _220801</div>
      <div class="title">公益项目信信息化管理系统</div>
      <div>研发单位：福州微时刻信息技术有限公司</div>
      <div class="container-wrapper">
        <div class="item">
          <div class="i-title">本产品使用权属于</div>
          <div>名称：微时刻信息技术公司</div>
          <div>编码：91350103315418997X</div>
        </div>
        <div class="item">
          <div class="i-title">已安装版本</div>
          <div>总 版 本 号：V1.0.6</div>
          <div>内部版本号：V1.0.0</div>
          <div>授 权 码：VS-350111-20210601001X</div>
          <div>授 权 Key：77cfee8356bb00cf9917f072f228ee10a9018197d55790717396a62609b2bd5246374c4f8b6185fcac4c7b491a3488c8fd972fd9eccd6747859f5069f40a7ba6a5d28bfb2fdb8d6b</div>
        </div>
        <div class="item">
          <div class="i-title">软件信息</div>
          <div>版本号：V1.0</div>
          <div>登记号：2023SR0557326</div>
          <div>流水号：2023R11L0454683</div>
        </div>
      </div>
      <div><img src="img/bg/jinggao.png"
             class="jg-icon">警告：本计算机程序受著作权法和国际公约保护，未经授权擅自复制或传播本程序的部分或全部，可能受到严厉的民事及刑事制裁，并将在法律许可的范围内受到最大可能的起诉。</div>
             <div>1、本系统及WEB、APP上展示的所有内容，包括但不限于文字表述及其组合、商标、标识、标志、图标、图形、图片、视频、音效、模型、网站架构、网站界面、网页设计、开发档案、资讯、资料等，均由我们依法拥有知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。</div>
             <div>2、非经书面同意，请勿擅自使用、修改、复制、公开传播、篡改、散布、反向编译、反汇编、反向工程、发行或公开发表APP程序或内容信息。</div>
    </div>
  </basic-container>
</template>
<script>
import { mapGetters } from "vuex";
import { getUserInfo } from "@/api/system/user";
export default {
  data () {
    return {

    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted () {
    getUserInfo().then(res => {
      this.deptDetail = res.data.data;
    });
  },
  methods: {


  }
};

</script>
<style lang="scss" scoped>
.about-wrapper {
  padding: 60px 15% 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
  line-height: 14px;
  color: rgba(109, 114, 120, 1);

  .logo {
    width: auto;
    height: 81px;
    margin-bottom: 28px;
  }

  .v-label {
    display: inline-block;
    color: #214e70;
    line-height: 26px;
    padding: 0 8px;
    background-color: #e7f0f8;
    border-radius: 6px;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .title {
    font-size: 28px;
    line-height: 33px;
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 1);
  }

  .container-wrapper {
    padding-top: 12px;
    margin-bottom: 60px;

    .item {
      margin-top: 38px;
    }

    .i-title {
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      margin-bottom: 12px;

      &:before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 12.5px;
        background-color: rgba(59, 161, 219, 1);
        margin-right: 5px;
      }
    }
  }
  .jg-icon {
    display: inline-block;
    vertical-align: top;
    width: 12px;
  }
}
</style>
